import React from "react";
import "./qa-card.scss";

class QACard extends React.Component {
  state = {
    device: "mobile"
  };
  componentDidMount() {
    this.setState({
      device: window.screen.availWidth < 850 ? "mobile" : "web"
    });
  }
  render() {
    return (
      <div
        className="qa-card-container"
        style={{
          backgroundColor: this.props.data.bgColor
        }}
      >
        <h2 className="card-title">{this.props.data.title}</h2>
        <h3 className="card-sub-title font-weight-normal">
          {this.props.data.subtitle}
        </h3>
      </div>
    );
  }
}

export default QACard;
